export default {"src":"/_next/static/media/Logo.9df3e39e.svg","height":108,"width":392,"blurWidth":0,"blurHeight":0};